module.exports = __webpack_public_path__ + "img/led_xq.7fd4b014.png";